export interface MonthlyTask {
  id: string;
  label: string;
  day: string;
  slot: string;
  duration: string;
}

export interface MonthlyWeek {
  week: string;
  color: string;
  accent: string;
  tasks: MonthlyTask[];
}

export interface MonthlyData {
  title: string;
  emoji: string;
  description: string;
  weeks: MonthlyWeek[];
}

// Monthly anchors spread across 4 weeks so nothing clusters on one day.
export const MONTHLY: MonthlyData = {
  title: "Monthly Anchors",
  emoji: "📅",
  description: "Spread across the month — one layer deeper than your weekly rhythm.",
  weeks: [
    {
      week: "Week 1 — Reset & Review",
      color: "#e8f4ff",
      accent: "#4a90d4",
      tasks: [
        { id: "mo1", label: "Deep clean refrigerator — clear, wipe shelves, discard expired",    day: "1st Saturday", slot: "Fits in: Saturday nap window 12:30–2p",   duration: "~20 min" },
        { id: "mo2", label: "Review personal goals — what's working, what needs adjusting",      day: "1st Sunday",   slot: "Fits in: Sunday reset window 8:30p",      duration: "~15 min" },
        { id: "mo3", label: "Schedule all upcoming appointments (medical, dental, toddler)",     day: "1st Saturday", slot: "Fits in: Saturday admin time 2:00p",      duration: "~10 min" },
        { id: "mo4", label: "Review & restock household supplies (cleaning, toiletries, pantry)", day: "1st Saturday", slot: "Fits in: Saturday grocery run — add to list", duration: "~15 min" },
      ],
    },
    {
      week: "Week 2 — Deep Home",
      color: "#fff0f8",
      accent: "#d46ba0",
      tasks: [
        { id: "mo5", label: "Deep clean oven & stovetop",                                       day: "2nd Wednesday", slot: "Fits in: Wednesday kitchen clean slot 9:30a", duration: "~25 min" },
        { id: "mo6", label: "Wipe down baseboards — living room & bedroom",                     day: "2nd Tuesday",   slot: "Fits in: Tuesday bedroom clean slot 9:30a",   duration: "~20 min" },
        { id: "mo7", label: "Clean out toddler's clothes — size check, donate outgrown items",  day: "2nd Saturday",  slot: "Fits in: Saturday outdoor play 3:00p (toddler with you, closet accessible)", duration: "~20 min" },
        { id: "mo8", label: "Wipe light switches, door handles & high-touch surfaces",          day: "2nd Thursday",  slot: "Fits in: Thursday living room clean 9:30a",   duration: "~10 min" },
      ],
    },
    {
      week: "Week 3 — Finances & Admin",
      color: "#f0fff4",
      accent: "#4cb87a",
      tasks: [
        { id: "mo9",  label: "Monthly budget review — income, spending, savings progress",     day: "3rd Saturday",  slot: "Fits in: Saturday admin time 2:00p",          duration: "~20 min" },
        { id: "mo10", label: "Pay any recurring bills or review subscriptions to cut",         day: "3rd Saturday",  slot: "Fits in: Saturday admin time 2:20p",          duration: "~15 min" },
        { id: "mo11", label: "Toddler development check-in — milestones, any concerns to note",day: "3rd Sunday",    slot: "Fits in: Sunday reset window 8:30p",          duration: "~10 min" },
        { id: "mo12", label: "Date night outside the home — plan & book if needed",            day: "3rd Thursday",  slot: "Fits in: Thursday nap window 1:30p (just book it)", duration: "reminder" },
      ],
    },
    {
      week: "Week 4 — Self & Space",
      color: "#fdf0ff",
      accent: "#9b6dd4",
      tasks: [
        { id: "mo13", label: "Deep clean bathrooms — grout, behind toilet, inside cabinets",   day: "4th Monday",    slot: "Fits in: Monday bathroom clean slot 10:30a",  duration: "~30 min" },
        { id: "mo14", label: "Wipe down kitchen cabinets & backsplash",                        day: "4th Wednesday", slot: "Fits in: Wednesday kitchen clean slot 9:30a", duration: "~20 min" },
        { id: "mo15", label: "Personal self-reflection — journal, intentions for next month",  day: "4th Sunday",    slot: "Fits in: Sunday alone time 9:00p",            duration: "~20 min" },
        { id: "mo16", label: "Rotate or wash throw pillows, blankets & couch cushion covers",  day: "4th Saturday",  slot: "Fits in: Saturday nap window 12:30–2p",       duration: "~20 min" },
      ],
    },
  ],
};

/** Returns the MonthlyWeek matching today's week-of-month, or null if out of range. */
export function getMonthlyTasksForToday(date: Date): MonthlyWeek | null {
  const week = Math.ceil(date.getDate() / 7);
  const weekIdx = week - 1;
  if (weekIdx < 0 || weekIdx > 3) return null;
  return MONTHLY.weeks[weekIdx];
}
